import angular from 'angular'
import 'ngVue'
import 'ngVue/build/plugins.js'
import store from '@/store/index'
import { VueAngularEventBus } from './eventBus'

const ngVueComponentsModule = angular.module('ngVueComponents', ['ngVue', 'ngVue.plugins'])
ngVueComponentsModule.config([
  '$ngVueProvider',
  function ($ngVueProvider) {
    $ngVueProvider.setRootVueInstanceProps({
      store: store
    })
  }
])

ngVueComponentsModule.factory(
  'VuexStore',
  [
    function () {
      return store
    }
  ]
)

ngVueComponentsModule.factory(
  'VueAngularEventBus',
  [
    function () {
      return VueAngularEventBus
    }
  ]
)

export default ngVueComponentsModule
